import {
    Paper,
    Skeleton,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
} from "@mui/material";
import React from "react";

const TableLoader = ({ columnCount = 5, rowCount = 5 }) => {
  const rows = Array.from(new Array(rowCount));
  const columns = Array.from(new Array(columnCount));

  return (
    <TableContainer component={Paper}>
      <Table>
        <TableHead>
          <TableRow>
            {columns.map((_, index) => (
              <TableCell key={`loading-table-header-${index}`}>
                <Skeleton variant="text" />
              </TableCell>
            ))}
          </TableRow>
        </TableHead>
        <TableBody>
          {rows.map((_, index) => (
            <TableRow key={`loading-table-row-${index}`}>
              {columns.map((_, colIndex) => (
                <TableCell key={`loading-table-content-${colIndex}`}>
                  <Skeleton variant="rectangular" height={40} />
                </TableCell>
              ))}
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default TableLoader;
